export enum HealthSystemFeedbackType {
    ADD = 'add entity health system',
}

export enum AddressAssociationFeedbackType {
    DELETE = 'delete association address health system',
    ADD = 'add association address health system',
    CONFIRM = 'confirm association address health system',
}

export enum PhoneFaxFeedbackType {
    DELETE = 'delete entity phone number',
    ADD = 'add entity phone number',
    CONFIRM = 'confirm entity phone number',
}

// feedback type: combination of address association feedback type and phone fax feedback type
export type FeedbackType = HealthSystemFeedbackType | AddressAssociationFeedbackType | PhoneFaxFeedbackType;

export enum FeedbackStatus {
    APPROVED = 'approved',
    REJECTED = 'rejected',
    PENDING = 'pending',
}

export type Address = {
    addressId: string;
    formattedAddress: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    postalCode: number;
};

export type FeedbackBase = {
    id?: number;
    feedbackType: FeedbackType;
    submissionSource: 'request manager';
    submitterId: string;
    contactEmail: string;
    healthSystemName?: string;
    healthSystemId: string;
    ein?: string;
    npi2?: string;
    status: FeedbackStatus;
    summary?: string;
    description?: string;
    assigneeEmail?: string;
    submittedAt?: string;
    roster: 'provider';
};

export interface AddressAssociationFeedback extends FeedbackBase {
    feedbackType: AddressAssociationFeedbackType;
    addressId: string;
    addressLine1: string;
    addressLine2?: string;
    city: string;
    state: string;
    postalCode: string;
    isAddressInSpine?: boolean;
    isInProviderRoster?: boolean;
    claimedByOtherHealthSystem?: boolean;
    similarAddressesExist?: boolean;
    similarAddresses?: Address[];
    checks?: {
        existingHealthSystemSelected: boolean;
        googleApiLookup: boolean;
    };
}

export interface HealthSystemFeedback extends FeedbackBase {
    feedbackType: HealthSystemFeedbackType;
    healthSystemName: string;
    npi2?: string;
    isNpiInSpine?: boolean;
    phoneNumber?: string;
    faxNumber?: string;
    ein?: string;
}

// Technically inherits from AddressAssociationFeedback in DF API but doesn't
// need an address, while we want to require it on the address feedback
export interface PhoneFaxFeedback extends FeedbackBase {
    feedbackType: PhoneFaxFeedbackType;
    number: string;
    numberType: 'phone' | 'fax';
}
